"use client";

import { useEffect, useState } from "react";
import { eventTodayString } from "../_logic/utils/schedule-utils";

/**
 * Resolves "today" as a `YYYY-MM-DD` string in the given event time zone, after the component
 * mounts on the client. Returns `null` during SSR and the first client render so the server and
 * client markup agree (no hydration mismatch) — the real value arrives one render after mount.
 *
 * Centralizes the mount-resolved "today" that both the Agenda and Calendar schedule views use to
 * auto-select today's day/column and drive the "now" line, so neither view re-implements the
 * resolve-on-mount dance.
 *
 * @param timeZone - The event's IANA time zone, or null for floating time (falls back to viewer zone).
 * @returns Today's date as `YYYY-MM-DD` in the event zone, or null before mount.
 */
export function useEventToday(timeZone: string | null): string | null {
  const [today, setToday] = useState<string | null>(null);

  useEffect(() => {
    setToday(eventTodayString(timeZone));
  }, [timeZone]);

  return today;
}
